import {DateTime} from 'luxon';
import {BankAccountType} from '../../../api/customerBankAccounts/CustomerBankAccount.ts';

export enum ConnectionStatus {
    Connected = 'CONNECTED',
    Expiring = 'EXPIRING',
    Expired = 'EXPIRED',
    Manual = 'MANUAL',
}

interface ConnectionState {
    accountType: BankAccountType;
    isExpired: boolean;
    expiresSoon: boolean;
    isPaymentProvider: boolean;
}

const JUST_NOW_SECONDS = 60;

export function resolveConnectionStatus({accountType, isExpired, expiresSoon, isPaymentProvider}: ConnectionState): ConnectionStatus {
    if (accountType === BankAccountType.SAVINGS) {
        return ConnectionStatus.Manual;
    }
    if (isPaymentProvider) {
        return ConnectionStatus.Connected;
    }
    if (isExpired) {
        return ConnectionStatus.Expired;
    }
    if (expiresSoon) {
        return ConnectionStatus.Expiring;
    }
    return ConnectionStatus.Connected;
}

export function keepsPanelOpen(status: ConnectionStatus): boolean {
    return status === ConnectionStatus.Expired;
}

export function formatLastSynced(refreshedOn: string, now: DateTime): string {
    const refreshed = DateTime.fromISO(refreshedOn);
    if (!refreshed.isValid) {
        return '';
    }
    if (now.diff(refreshed).as('seconds') < JUST_NOW_SECONDS) {
        return 'zojuist';
    }
    return refreshed.setLocale('nl').toRelative({base: now}) ?? '';
}
